import { render, staticRenderFns } from "./modalHorasInterBase.vue?vue&type=template&id=eb5efaea&scoped=true&"
import script from "./modalHorasInterBase.vue?vue&type=script&lang=js&"
export * from "./modalHorasInterBase.vue?vue&type=script&lang=js&"
import style0 from "./modalHorasInterBase.vue?vue&type=style&index=0&id=eb5efaea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5efaea",
  null
  
)

export default component.exports